import React, { useState, Fragment } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Markdown from "markdown-to-jsx";
import Modal from "src/react/components/modal";
import Button from "src/react/components/button";

function AdditionalInfo({
  additionalInformationCtaText,
  additionalInformation,
}) {
  const [isVisible, setIsVisible] = useState(false);

  const content = <Markdown>{additionalInformation}</Markdown>;

  return (
    <Fragment>
      <Button
        variant="outline"
        size="small"
        fullWidth
        onClick={() => setIsVisible(true)}
      >
        {additionalInformationCtaText}
      </Button>
      <AccessibleContent>
        <h2>{additionalInformationCtaText}</h2>
        {content}
      </AccessibleContent>
      {isVisible && (
        <Modal closeModal={() => setIsVisible(false)}>
          <Title>{additionalInformationCtaText}</Title>
          {content}
        </Modal>
      )}
    </Fragment>
  );
}

AdditionalInfo.propTypes = {
  additionalInformationCtaText: PropTypes.string,
  additionalInformation: PropTypes.string,
};

export default AdditionalInfo;

const AccessibleContent = styled.div`
  display: none;
`;

const Title = styled.h2`
  font-weight: 600;
  font-size: 20px;
  @media (min-width: 768px) {
    font-size: 24px;
  }
`;
